// Caption under the priyankavasandiya.com button (flat contact + journey
// finale). Owner-verbatim copy; the leading question renders as an amber
// hook — the site's inline-emphasis vocabulary — inside a soft amber callout
// so it reads as an intentional note, not fine print.
export function SiteNote({ note }) {
  if (!note) return null;
  const q = note.indexOf('?');
  if (q === -1) return <p className="site-note">{note}</p>;
  return (
    <p className="site-note">
      <span className="site-note-hook">{note.slice(0, q + 1)}</span>
      {note.slice(q + 1)}
    </p>
  );
}
